import React, {useEffect} from 'react'
import {observer} from 'mobx-react-lite'
import {useLocation} from 'react-router-dom'
import clubStore from '../../../storage/ClubStore'
import appStore from '../../../storage/AppStore'
import PageLayout from '../../PageLayout'
import BillingItem from '../ParentMember/BillingItem'

const MemberBilling = () => {
  const location = useLocation()
  const child = clubStore.child

  useEffect(() => {
    const load = async () => {
      child.setProperty('billing', [])
      if (!child.company_id) return
      if (!child.child_id) await child.getChild()
      if (child.child_id) await child.getBilling()
    }
    load()
  }, [child.company_id, location.pathname])

  return (
    <PageLayout header={
      <div className="flex justify-content-between align-items-center">
        <h3 className="m-0">{appStore.tr.billing}</h3>
      </div>
    }>
      {child.billing.length === 0 ? (
        <div className="flex flex-column align-items-center justify-content-center py-5 text-600">
          <i className="pi pi-wallet mb-2" style={{fontSize: '2rem'}}/>
          <span>{appStore.tr.not_found}</span>
        </div>
      ) : child.billing.map(period => (
        <BillingItem period={period} key={`${period.year}-${period.month}`} url_base="/member"/>
      ))}
    </PageLayout>
  )
}

export default observer(MemberBilling)